/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Win_Back_B_TitleInputs */

const en_win_back_b_title = /** @type {(inputs: Win_Back_B_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`<span style="#2AFD00">${i?.number}</span> Off
Your First Year Back`)
};

const ar_win_back_b_title = /** @type {(inputs: Win_Back_B_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`خصم <span style="#2AFD00">${i?.number}</span> على سنتك الأولى
عند العودة إلى الخطة السنوية`)
};

const de_win_back_b_title = /** @type {(inputs: Win_Back_B_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`<span style="#2AFD00">${i?.number}</span> Rabatt
im ersten Jahr bei erneutem Abo`)
};

const es_win_back_b_title = /** @type {(inputs: Win_Back_B_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`<span style="#2AFD00">${i?.number}</span> de descuento
en el primer año al volver a suscribirte`)
};

const fr_win_back_b_title = /** @type {(inputs: Win_Back_B_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`<span style="#2AFD00">${i?.number}</span> de réduction
la première année de réabonnement`)
};

const it_win_back_b_title = /** @type {(inputs: Win_Back_B_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`<span style="#2AFD00">${i?.number}</span> di sconto
sul primo anno di riabbonamento`)
};

const ja_win_back_b_title = /** @type {(inputs: Win_Back_B_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`年間プランへの再登録で
初年度が<span style="#2AFD00">${i?.number}</span>オフ`)
};

const ko_win_back_b_title = /** @type {(inputs: Win_Back_B_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`연간 플랜 재구독 시
첫해 <span style="#2AFD00">${i?.number}</span> 할인`)
};

const pt_br_win_back_b_title = /** @type {(inputs: Win_Back_B_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`<span style="#2AFD00">${i?.number}</span> de desconto no primeiro ano
ao voltar ao plano anual`)
};

const ru_win_back_b_title = /** @type {(inputs: Win_Back_B_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Скидка <span style="#2AFD00">${i?.number}</span> на первый год
при возвращении на годовой план`)
};

const th_win_back_b_title = /** @type {(inputs: Win_Back_B_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`กลับมาสมัครแผนรายปี
รับส่วนลด <span style="#2AFD00">${i?.number}</span> ในปีแรก`)
};

const tr_win_back_b_title = /** @type {(inputs: Win_Back_B_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Yıllık plana geri dön,
ilk yıl <span style="#2AFD00">${i?.number}</span> indirim kazan`)
};

const zh_cn_win_back_b_title = /** @type {(inputs: Win_Back_B_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`重新订阅连续包年方案，
首年享 <span style="#2AFD00">${i?.number}</span> 优惠`)
};

const zh_tw_win_back_b_title = /** @type {(inputs: Win_Back_B_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`重新訂閱年方案，
首年享 <span style="#2AFD00">${i?.number}</span> 優惠`)
};

/**
* | output |
* | --- |
* | "<span style=\"#2AFD00\">{number}</span> Off Your First Year Back" |
*
* @param {Win_Back_B_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const win_back_b_title = /** @type {((inputs: Win_Back_B_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Win_Back_B_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_win_back_b_title(inputs)
	if (locale === "ar") return ar_win_back_b_title(inputs)
	if (locale === "de") return de_win_back_b_title(inputs)
	if (locale === "es") return es_win_back_b_title(inputs)
	if (locale === "fr") return fr_win_back_b_title(inputs)
	if (locale === "it") return it_win_back_b_title(inputs)
	if (locale === "ja") return ja_win_back_b_title(inputs)
	if (locale === "ko") return ko_win_back_b_title(inputs)
	if (locale === "pt_br") return pt_br_win_back_b_title(inputs)
	if (locale === "ru") return ru_win_back_b_title(inputs)
	if (locale === "th") return th_win_back_b_title(inputs)
	if (locale === "tr") return tr_win_back_b_title(inputs)
	if (locale === "zh_cn") return zh_cn_win_back_b_title(inputs)
	return zh_tw_win_back_b_title(inputs)
});